import { CopyIcon } from '@approvalmax/ui';
import { Box, Button, Flex, Grid, Spacing, Text } from '@approvalmax/ui/src/components';
import { ComponentType, useCallback } from 'react';

import { Loading } from './FundWalletCard.loading';
import { messages } from './FundWalletCard.messages';
import { ChildrenComponents, FundWalletCardProps } from './FundWalletCard.types';

export const FundWalletCard = ((props: FundWalletCardProps) => {
    const { title, description, disabled = false, children, onCopy } = props;

    const handleCLick = useCallback(() => {
        onCopy?.();
    }, [onCopy]);

    return (
        <Box bordered borderColor='midnight50' radius='medium' spacing='0 24 16'>
            <Flex alignItems='center' height={52} justifyContent='space-between'>
                <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight80'>
                    {title}
                </Text>

                <Button
                    color='blue10'
                    size='xsmall'
                    startIcon={<CopyIcon size='12' />}
                    onClick={handleCLick}
                    disabled={disabled}
                >
                    {messages.copy}
                </Button>
            </Flex>

            <Text font='label' fontSize='small' color='midnight70'>
                {description}
            </Text>

            <Spacing height={16} />

            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                {children}
            </Grid>
        </Box>
    );
}) as ComponentType<FundWalletCardProps> & ChildrenComponents;

FundWalletCard.displayName = 'FundWalletCard';
FundWalletCard.Loading = Loading;
